// This file is auto-generated by scripts/generate-excel-mapping.js
// Do not edit manually.

export const EXCEL_TEMPLATE_ANCHORS = {
  "cmrt": {
    "6.01": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55,
        "7": 61,
        "8": 67
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 5,
        "7": 5,
        "8": 7
      },
      "companyHeaderRowByKey": {
        "A": 75,
        "B": 77,
        "C": 79,
        "D": 81,
        "E": 83,
        "F": 85,
        "G": 87,
        "H": 89
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 1,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 1,
        "H": 21
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    },
    "6.1": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55,
        "7": 61,
        "8": 67
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 5,
        "7": 5,
        "8": 7
      },
      "companyHeaderRowByKey": {
        "A": 75,
        "B": 77,
        "C": 79,
        "D": 81,
        "E": 83,
        "F": 85,
        "G": 87,
        "H": 89
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 1,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 1,
        "H": 21
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    },
    "6.22": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55,
        "7": 61,
        "8": 67
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 5,
        "7": 5,
        "8": 7
      },
      "companyHeaderRowByKey": {
        "A": 75,
        "B": 77,
        "C": 79,
        "D": 81,
        "E": 83,
        "F": 85,
        "G": 87,
        "H": 89
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 1,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 1,
        "H": 21
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    },
    "6.31": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55,
        "7": 61,
        "8": 67
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 5,
        "7": 5,
        "8": 7
      },
      "companyHeaderRowByKey": {
        "A": 75,
        "B": 77,
        "C": 79,
        "D": 81,
        "E": 83,
        "F": 85,
        "G": 87,
        "H": 89
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 1,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 1,
        "H": 21
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    },
    "6.4": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55,
        "7": 61,
        "8": 67
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 5,
        "7": 5,
        "8": 7
      },
      "companyHeaderRowByKey": {
        "A": 75,
        "B": 77,
        "C": 79,
        "D": 81,
        "E": 83,
        "F": 85,
        "G": 87,
        "H": 89
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 1,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 1,
        "H": 21
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    },
    "6.5": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55,
        "7": 61,
        "8": 67
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 5,
        "7": 5,
        "8": 7
      },
      "companyHeaderRowByKey": {
        "A": 75,
        "B": 77,
        "C": 79,
        "D": 81,
        "E": 83,
        "F": 85,
        "G": 87,
        "H": 89
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 1,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 1,
        "H": 21
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    },
    "6.6": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55,
        "7": 61,
        "8": 67
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 5,
        "7": 5,
        "8": 7
      },
      "companyHeaderRowByKey": {
        "A": 75,
        "B": 77,
        "C": 79,
        "D": 81,
        "E": 83,
        "F": 85,
        "G": 87,
        "H": 89
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 1,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 1,
        "H": 21
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    },
    "6.6.1": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55,
        "7": 61,
        "8": 67
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 5,
        "7": 5,
        "8": 7
      },
      "companyHeaderRowByKey": {
        "A": 75,
        "B": 77,
        "C": 79,
        "D": 81,
        "E": 83,
        "F": 85,
        "G": 87,
        "H": 89
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 1,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 1,
        "H": 21
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    }
  },
  "emrt": {
    "1.1": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55,
        "7": 61
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 5,
        "7": 7
      },
      "companyHeaderRowByKey": {
        "A": 69,
        "B": 71,
        "C": 73,
        "D": 77,
        "E": 79,
        "F": 81,
        "G": 83
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 3,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 36
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    },
    "1.11": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55,
        "7": 61
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 5,
        "7": 7
      },
      "companyHeaderRowByKey": {
        "A": 69,
        "B": 71,
        "C": 73,
        "D": 77,
        "E": 79,
        "F": 81,
        "G": 83
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 3,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 36
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    },
    "1.2": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55,
        "7": 61
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 5,
        "7": 7
      },
      "companyHeaderRowByKey": {
        "A": 69,
        "B": 71,
        "C": 73,
        "D": 77,
        "E": 79,
        "F": 81,
        "G": 83
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 3,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 36
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    },
    "1.3": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55,
        "7": 61
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 5,
        "7": 7
      },
      "companyHeaderRowByKey": {
        "A": 69,
        "B": 71,
        "C": 73,
        "D": 77,
        "E": 79,
        "F": 81,
        "G": 83
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 3,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 36
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    },
    "2.0": {
      "questionHeaderRowByNumber": {
        "1": 29,
        "2": 41,
        "3": 53,
        "4": 65,
        "5": 77,
        "6": 89,
        "7": 101
      },
      "questionSpanByNumber": {
        "1": 11,
        "2": 11,
        "3": 11,
        "4": 11,
        "5": 11,
        "6": 11,
        "7": 13
      },
      "companyHeaderRowByKey": {
        "A": 115,
        "B": 117,
        "C": 119,
        "D": 131,
        "E": 133,
        "F": 135,
        "G": 137
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 11,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 50
      },
      "amrtQ1Row": 29,
      "amrtQ2Row": 41,
      "amrtQ3Row": 53
    },
    "2.1": {
      "questionHeaderRowByNumber": {
        "1": 29,
        "2": 41,
        "3": 53,
        "4": 65,
        "5": 77,
        "6": 89,
        "7": 101
      },
      "questionSpanByNumber": {
        "1": 11,
        "2": 11,
        "3": 11,
        "4": 11,
        "5": 11,
        "6": 11,
        "7": 13
      },
      "companyHeaderRowByKey": {
        "A": 115,
        "B": 117,
        "C": 119,
        "D": 131,
        "E": 133,
        "F": 135,
        "G": 137
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 11,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 50
      },
      "amrtQ1Row": 29,
      "amrtQ2Row": 41,
      "amrtQ3Row": 53
    },
    "2.11": {
      "questionHeaderRowByNumber": {
        "1": 29,
        "2": 41,
        "3": 53,
        "4": 65,
        "5": 77,
        "6": 89,
        "7": 101
      },
      "questionSpanByNumber": {
        "1": 11,
        "2": 11,
        "3": 11,
        "4": 11,
        "5": 11,
        "6": 11,
        "7": 13
      },
      "companyHeaderRowByKey": {
        "A": 115,
        "B": 117,
        "C": 119,
        "D": 131,
        "E": 133,
        "F": 135,
        "G": 137
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 11,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 50
      },
      "amrtQ1Row": 29,
      "amrtQ2Row": 41,
      "amrtQ3Row": 53
    },
    "2.11.1": {
      "questionHeaderRowByNumber": {
        "1": 29,
        "2": 41,
        "3": 53,
        "4": 65,
        "5": 77,
        "6": 89,
        "7": 101
      },
      "questionSpanByNumber": {
        "1": 11,
        "2": 11,
        "3": 11,
        "4": 11,
        "5": 11,
        "6": 11,
        "7": 13
      },
      "companyHeaderRowByKey": {
        "A": 115,
        "B": 117,
        "C": 119,
        "D": 131,
        "E": 133,
        "F": 135,
        "G": 137
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 11,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 50
      },
      "amrtQ1Row": 29,
      "amrtQ2Row": 41,
      "amrtQ3Row": 53
    }
  },
  "crt": {
    "2.2": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 7
      },
      "companyHeaderRowByKey": {
        "A": 63,
        "B": 65,
        "C": 67,
        "D": 69,
        "E": 71,
        "F": 73,
        "G": 75,
        "H": 77,
        "I": 79
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 1,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 1,
        "H": 1,
        "I": 21
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    },
    "2.21": {
      "questionHeaderRowByNumber": {
        "1": 25,
        "2": 31,
        "3": 37,
        "4": 43,
        "5": 49,
        "6": 55
      },
      "questionSpanByNumber": {
        "1": 5,
        "2": 5,
        "3": 5,
        "4": 5,
        "5": 5,
        "6": 7
      },
      "companyHeaderRowByKey": {
        "A": 63,
        "B": 65,
        "C": 67,
        "D": 69,
        "E": 71,
        "F": 73,
        "G": 75,
        "H": 77,
        "I": 79
      },
      "companySpanByKey": {
        "A": 1,
        "B": 1,
        "C": 1,
        "D": 1,
        "E": 1,
        "F": 1,
        "G": 1,
        "H": 1,
        "I": 21
      },
      "amrtQ1Row": 25,
      "amrtQ2Row": 31,
      "amrtQ3Row": 37
    }
  },
  "amrt": {
    "1.1": {
      "questionHeaderRowByNumber": {
        "1": 27,
        "2": 39
      },
      "questionSpanByNumber": {
        "1": 11,
        "2": 29
      },
      "companyHeaderRowByKey": {},
      "companySpanByKey": {},
      "amrtQ1Row": 27,
      "amrtQ2Row": 39,
      "amrtQ3Row": null
    },
    "1.2": {
      "questionHeaderRowByNumber": {
        "1": 27,
        "2": 39
      },
      "questionSpanByNumber": {
        "1": 11,
        "2": 29
      },
      "companyHeaderRowByKey": {},
      "companySpanByKey": {},
      "amrtQ1Row": 27,
      "amrtQ2Row": 39,
      "amrtQ3Row": null
    },
    "1.3": {
      "questionHeaderRowByNumber": {
        "1": 30,
        "2": 42
      },
      "questionSpanByNumber": {
        "1": 11,
        "2": 37
      },
      "companyHeaderRowByKey": {},
      "companySpanByKey": {},
      "amrtQ1Row": 30,
      "amrtQ2Row": 42,
      "amrtQ3Row": null
    },
    "1.31": {
      "questionHeaderRowByNumber": {
        "1": 30,
        "2": 42
      },
      "questionSpanByNumber": {
        "1": 11,
        "2": 43
      },
      "companyHeaderRowByKey": {},
      "companySpanByKey": {},
      "amrtQ1Row": 30,
      "amrtQ2Row": 42,
      "amrtQ3Row": null
    },
    "1.31.1": {
      "questionHeaderRowByNumber": {
        "1": 30,
        "2": 42
      },
      "questionSpanByNumber": {
        "1": 11,
        "2": 43
      },
      "companyHeaderRowByKey": {},
      "companySpanByKey": {},
      "amrtQ1Row": 30,
      "amrtQ2Row": 42,
      "amrtQ3Row": null
    }
  }
} as const
